import {CopilotChatSidePanel} from '@github-ui/copilot-chat-side-panel/CopilotChatSidePanel'
import {useCopilotSidePanelIntegration} from '@github-ui/copilot-chat-side-panel/useCopilotSidePanelIntegration'

/**
 * Integrates the copilot side panel with the code view page.
 * Closes the immersive embedded panel on mount and intercepts
 * open-copilot-chat / add-reference events so chat opens in
 * the docked side panel instead.
 */
export function CopilotCodeViewIntegration() {
  const {togglePanelRef, isOpen, actions} = useCopilotSidePanelIntegration()

  return <CopilotChatSidePanel isOpen={isOpen} onClose={actions.closePanel} toggleSidesheetRef={togglePanelRef} />
}
